import { LOGIN_PATH } from '../../api/paths';
import { FORBIDDEN_ERROR_MESSAGE } from '../data/useLoginVerify';
import { getIsPreview } from './isPreview';
const getCookieByName = name => {
  const matches = document.cookie.match(`(?:^|;\\s*)${name}=(.*?)(?:;|$)`);
  if (matches) {
    return decodeURIComponent(matches[1]);
  }
  return undefined;
};
export const api = async (path, init) => {
  const {
    isPreview,
    previewJwt,
    portalId
  } = getIsPreview();
  const url = new URL(path, window.location.origin);
  if (isPreview) {
    url.searchParams.set('portalId', portalId);
  }
  const seleniumCookie = getCookieByName('hs_selenium');
  if (seleniumCookie) {
    url.searchParams.set('hs_selenium_test', seleniumCookie);
  }
  const headers = Object.assign({
    'X-HS-User-Request': '1'
  }, init === null || init === void 0 ? void 0 : init.headers);
  if (isPreview) {
    headers.Authorization = `Bearer ${previewJwt}`;
  }
  const response = await fetch(url, Object.assign({}, init, {
    headers
  }));
  const {
    origin,
    href
  } = window.location;
  if (response.status === 401) {
    const loginUrl = new URL(LOGIN_PATH, origin);
    loginUrl.searchParams.set('redirect_url', href);
    window.location.href = loginUrl.toString();
  }
  if (response.status === 403) {
    throw new Error(FORBIDDEN_ERROR_MESSAGE);
  }
  if (response.status >= 400 && response.status !== 401) {
    const error = new Error(`Request failed with status ${response.status}`);
    error.status = response.status;
    error.url = response.url;
    throw error;
  }
  return response;
};